document.addEventListener("DOMContentLoaded", () => {
  const relatedLocationsContainer = document.querySelector(
    ".relatedLocations__carousel .swiper"
  );

  if (!relatedLocationsContainer) return;

  const swiper = new Swiper(relatedLocationsContainer, {
    slidesPerView: 1.2,
    spaceBetween: 40,

    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },

    scrollbar: {
      el: ".swiper-scrollbar",
      draggable: false,
    },

    breakpoints: {
      500: {
        slidesPerView: 1.5,
      },
      768: {
        slidesPerView: 2,
      },
      991: {
        slidesPerView: 3,
      },
      1280: {
        slidesPerView: 4,
        spaceBetween: 48,
      },
    },
  });
});
